import { action, computed, makeObservable, observable } from 'mobx';

import type { DrugHistoryData } from 'chaika-frontend-types/frontend-cms';
import { DrugStatus } from 'chaika-enums';

import { DateHelper } from '@utils/DateHelper';
import { assignParams } from '@utils/assignParams';

interface MetaData {
    entryId: string;
}

export class DrugHistory {
    @observable public readonly id!: string;
    @observable public readonly ehrId!: string;
    @observable public readonly authorId!: string;
    @observable public readonly parentEntryId!: string;
    @observable public readonly createdAt!: string;
    @observable public status!: DrugStatus;
    @observable public activeSubstance!: string;
    @observable public tradeNameIds?: string[];
    @observable public customTradeNames?: string[];
    @observable public frequencyIfReception!: string;
    @observable public directions?: string;
    @observable public start?: string;
    @observable public end?: string;
    @observable public metaData!: MetaData[];

    constructor(params: DrugHistoryData) {
        makeObservable(this);
        assignParams<DrugHistoryData>(this, params);
    }

    @computed
    public get isActive(): boolean {
        return this.status === DrugStatus.Active;
    }

    @computed
    public get isActual(): boolean {
        return !this.end || DateHelper.isAfter(this.end, Date.now());
    }

    @action
    public update({ activeSubstance, frequencyIfReception, directions, start, end }: Partial<DrugHistoryData>): void {
        this.activeSubstance = activeSubstance ?? this.activeSubstance;
        this.frequencyIfReception = frequencyIfReception ?? this.frequencyIfReception;
        this.directions = directions ?? this.directions;
        this.start = start ?? this.start;
        this.end = end ?? this.end;
    }

    public serialize(): DrugHistoryData {
        return {
            id: this.id,
            ehrId: this.ehrId,
            authorId: this.authorId,
            parentEntryId: this.parentEntryId,
            createdAt: this.createdAt,
            status: this.status,
            activeSubstance: this.activeSubstance,
            frequencyIfReception: this.frequencyIfReception,
            directions: this.directions,
            start: this.start,
            end: this.end,
            metaData: this.metaData,
        };
    }
}
